module.exports = __webpack_public_path__ + "media/img/security-phone-47945b07a3e745ec586be6f424f5817d.png";